import React, {useContext} from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import {InvitesContext} from "../context/InvitesContext";
import {EventsContext} from "../context/EventsContext";
import {handleChangeFactory} from "../utils/EventHandlerUtils";

export default function EventDetails(props) {
  const { classes } = props;
    const invitesContext = useContext(InvitesContext);
    const eventsContext = useContext(EventsContext);
    const eventTypes = eventsContext.eventTypes;
    const handleChange = handleChangeFactory(invitesContext.dispatch);

  return (
    <Grid container spacing={2} noValidate className={classes.inputContainer}>
      <Grid item xs={12} className={classes.noPadding}>
        <Paper square elevation={0} className={classes.inputTitleContainer}>
          <Typography className={classes.inputTitleText}>Titlu *</Typography>
        </Paper>
        <TextField
          fullWidth
          className={classes.inputFieldContainer}
          margin="normal"
          name="eventTitle"
          placeholder="ex. Ana si Vlad"
          onChange={handleChange}
          defaultValue={invitesContext.state.invite.eventTitle}
        />
      </Grid>
      <Grid item xs={12} className={classes.noPadding}>
        <Paper square elevation={0} className={classes.inputTitleContainer}>
          <Typography className={classes.inputTitleText}>Tipul evenimentului *</Typography>
        </Paper>
        <TextField
          value={invitesContext.state.invite.eventTypeId}
          select
          fullWidth
          className={classes.inputFieldContainer}
          margin="normal"
          name="eventTypeId"
          onChange={handleChange}
          inputProps={{MenuProps: {
            disableScrollLock: true,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            },
            getContentAnchorEl: null}
          }}
        >
          {eventTypes.map(eventType => <MenuItem key={eventType.code} value={eventType.id}>{eventType.name}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12} className={classes.noPadding}>
        <Paper square elevation={0} className={classes.inputTitleContainer}>
          <Typography className={classes.inputTitleText}>Text invitație</Typography>
        </Paper>
        <TextField
          fullWidth
          multiline
          className={`${classes.inputFieldContainer} ${classes.noMaxHeight}`}
          name="eventDescription"
          placeholder="Ex: Cu mare bucurie vă invităm la nunta noastră alături de cei dragi nouă. Suntem foarte încântați să ne sărbătorim căsătoria și sperăm că ne veți putea fi alături."
          onChange={handleChange}
          defaultValue={invitesContext.state.invite.eventDescription}
        />
      </Grid>
    </Grid>
  )
}